import {Routes, Route} from 'react-router-dom'
import './App.css';
import NavBar from './components/NavBar';
import Home from './pages/Home';
//import Shop from './pages/Shop';
//import Collection from './pages/Collection';
//import SingleProduct from './pages/SingleProduct';
import { CartProvider } from './contexts/CartContext';
//import Cart from './pages/Cart';
import Footer from './components/Footer';
import Tos from './pages/Tos';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { AuthProvider } from './contexts/AuthContext';
import AdminDashboard from './pages/AdminDashboard';
import Login from './pages/Login';
import AdminBar from './components/AdminBar';

import AnnouncementBar from './components/AnnouncementBar';
import { useEffect, useState } from 'react';
import { getAnnouncementBarFromFirestore } from './apis/firebase';





function App() {
  
  const [announcementBar, setAnnouncementBar] = useState(null)

  useEffect(() => {
    const loadBar = async () => {
      const bar = await getAnnouncementBarFromFirestore()
      setAnnouncementBar(bar[0])
    }
    loadBar()
    
  }, [])


  return (

    <div className="App">
      <AuthProvider>
      <CartProvider>
      <header className="App-header">
        <AdminBar/>
        {(announcementBar && announcementBar.visible) && <AnnouncementBar message={announcementBar.message}/>}
        <NavBar/>
      </header>

      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/privacy' element={<PrivacyPolicy/>}></Route>
        <Route path='/admin' element={<AdminDashboard/>}></Route>
        <Route path='/login' element={<Login/>}></Route>
        <Route path='/tos' element={<Tos/>}></Route>
        
      </Routes>
      <Footer/>
      </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
